import { supabase } from './supabase';
const TABLAS = {
  alqos_ncs:                  'ncs',
  alqos_ots:                  'ots',
  alqos_acciones_correctivas: 'acciones',
  alqos_caps:                 'capacitaciones',
  alqos_fmea:                 'fmeas',
  alqos_tpm:                  'tpm',
  alqos_capabilidad:          'capabilidad',
  alqos_auditorias:           'auditorias',
  alqos_programa_auditorias:  'programa_auditorias',
  alqos_analisis_causa:       'analisis_causa',
  alqos_docs:                 'documentos',
  alqos_ingreso_materiales:   'ingreso_materiales',
  alqos_huella_carbono:       'huella_carbono',
  alqos_haccp:                'haccp',
  alqos_poes:                 'poes',
  alqos_preprensa:            'preprensa',
  alqos_preprensa_planchas:   'preprensa_planchas',
  alqos_stock_pallets:        'stock_pallets',
  alqos_stock_movimientos:    'stock_movimientos',
  alqos_ce_contactos:         'ce_contactos',
  alqos_ce_aranceles:         'ce_aranceles',
  alqos_notas_comerciales:    'notas_comerciales',
  alqos_agenda_comercial:     'agenda_comercial',
  alqos_escritorio_calidad_tareas:   'escritorio_calidad_tareas',
  alqos_escritorio_calidad_stickers: 'escritorio_calidad_stickers',
  alqos_hs: 'hs_registros',
  alqos_consultor_empresas: 'hs_consultor_empresas',
  alqos_legalmatrix_empresas: 'hs_legalmatrix_empresas',
  alqos_consultor_visitas: 'hs_consultor_visitas',
  alqos_consultor_hallazgos: 'hs_consultor_hallazgos',
  alqos_consultor_stickers: 'hs_consultor_stickers',
  alqos_consultor_tareas: 'hs_consultor_tareas',
  alqos_consultor_aspectos: 'hs_consultor_aspectos',
  alqos_consultor_objetivos: 'hs_consultor_objetivos',
  alqos_programas_anuales:   'hs_programas_anuales',
  alqos_mapa_procesos: 'mapa_procesos',
  alqos_instructivos: 'instructivos',
  alqos_centros_costo: 'centros_costo',
  alqos_motor_costeo: 'motor_costeo',
  alqos_ventas: 'ventas',
  alqos_rrhh: 'empleados',
  alqos_cotizaciones: 'cotizaciones',
  alqos_tipos_material: 'tipos_material',
  dd_proyectos: 'dd_proyectos',
  alqos_oficina_tecnica: 'oficina_tecnica',
  alqos_trazabilidad: 'trazabilidad',
  alqos_ciberseg_inc: 'ciberseg_inc',
  alqos_ciberseg_activos: 'ciberseg_activos',
  alqos_ciberseg_ctrl: 'ciberseg_ctrl',
  alqos_despachos: 'despachos',
  alqos_feedback: 'feedback',
  et_specs: 'et_specs',
  alqos_plancontrol: 'plancontrol',
  alqos_capabilidad_config: 'capabilidad_config',
  alqos_produccion: 'produccion',
  alqos_fsc_arqueo: 'fsc_arqueo',
  alqos_clientes: 'clientes',
  alqos_proveedores: 'proveedores',
  alqos_compras: 'compras',
  alqos_sust_consumos: 'sust_consumos',
  alqos_sust_residuos: 'sust_residuos',
  alqos_sust_objetivos: 'sust_objetivos',
  alqos_sust_aspectos: 'sust_aspectos',
  alqos_sust_legal: 'sust_legal',
  alqos_sust_config_consumos: 'sust_config_consumos',
  alqos_sust_config_residuos: 'sust_config_residuos',
  alqos_programas_calidad_cliente: 'programas_calidad_cliente',
  alqos_checklist_templates: 'checklist_templates',
  alqos_fase_familia_linea: 'fase_familia_linea',
  alqos_indicadores_mensuales: 'indicadores_mensuales_familia',
  alqos_familias: 'familias',
  alqos_maquinas: 'maquinas',
  alqos_conformes: 'conformes',
  alqos_ce_exportaciones: 'ce_exportaciones',
  alqos_ce_importaciones: 'ce_importaciones',
  alqos_plan_cuentas: 'alqos_plan_cuentas',
  alqos_asientos: 'alqos_asientos',
  alqos_asientos_lineas: 'alqos_asientos_lineas',
  alqos_cxc_cxp: 'alqos_cxc_cxp',
  alqos_movimientos_caja: 'alqos_movimientos_caja',
  alqos_config_materiales: 'config_materiales',
  alqos_news: 'alqos_news',
  alqos_reportes_maquina: 'reportes_maquina',
  alqos_aql_resultados: 'aql_resultados',
  alqos_control_piso: 'control_piso',
  alqos_checklist_tipos: 'checklist_tipos',
};
// ─── Fase A multi-tenant: tenant_id del usuario logueado ──────
// Seteado por GestorUsuarios.js (autenticarSupabase) al iniciar sesión.
// Se lee acá adentro en vez de recibirlo como parámetro para NO tener que
// cambiar la firma de subirDatos/subirDatosSingle ni los ~58 módulos que
// las llaman hoy con solo el storageKey. RLS ya bloquea cualquier fila que
// no sea del tenant correcto -- este chequeo es para fallar rápido y con un
// mensaje claro en vez de un error crudo de Postgres por columna NOT NULL.
function getTenantId() {
  const raw = localStorage.getItem('alqos_tenant_id');
  const id = raw ? Number(raw) : NaN;
  return Number.isFinite(id) ? id : null;
}
// ─── SUBIR un storage key a Supabase ──────────────────────────
export async function subirDatos(storageKey) {
  const tabla = TABLAS[storageKey];
  if (!tabla) return;
  const tenantId = getTenantId();
  if (!tenantId) {
    console.error(`subirDatos(${storageKey}): no hay tenant_id en la sesión, no se sube nada.`);
    return;
  }
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return;
    const items = JSON.parse(raw);
    if (!Array.isArray(items)) return;
    for (const item of items) {
      if (!item?.id) continue;
      const { error } = await supabase.from(tabla).upsert({ id: item.id, data: item, tenant_id: tenantId });
      if (error) console.error(`Error subiendo ${storageKey} (id ${item.id}):`, error);
    }
  } catch(e) { console.error(`Error subiendo ${storageKey}:`, e); }
}
// ─── BAJAR un storage key desde Supabase ──────────────────────
export async function bajarDatos(storageKey) {
  const tabla = TABLAS[storageKey];
  if (!tabla) return false;
  try {
    const { data, error } = await supabase.from(tabla).select('data');
    if (error) { console.error(`Error bajando ${storageKey}:`, error); return false; }
    const items = (data || []).map(row => row.data).filter(Boolean);
    localStorage.setItem(storageKey, JSON.stringify(items));
    return true;
  } catch(e) { console.error(`Error bajando ${storageKey}:`, e); return false; }
}
// ─── CASO ESPECIAL: Factores custom de Huella de Carbono ──────
// hc_factores_custom se guarda como objeto {[alcance]: [...factores]}, no array.
// El upload lo hace HuellaCarbono.js directamente vía supabase.from('hc_factores_custom').upsert({id:tenantId,...})
// Fase C pendiente #3 (resuelto sin SQL): id = tenant_id, así cada tenant tiene su
// propia fila sin necesidad de constraint nueva.
async function bajarHcFactoresCustom() {
  const tenantId = getTenantId();
  if (!tenantId) return;
  try {
    const { data, error } = await supabase.from('hc_factores_custom').select('data').eq('id', tenantId).maybeSingle();
    if (error) { console.error('Error bajando hc_factores_custom:', error); return; }
    // Fase 8 (mismo criterio que bajarDatos()): 0 filas no es un error, es
    // "este tenant no tiene factores custom" -- hay que limpiar la caché
    // igual, si no un tenant sin factores custom (o que los borró) sigue
    // viendo los de una sesión/tenant anterior en este dispositivo.
    // removeItem (no un literal {}/null) para que el consumidor use el
    // mismo default que ya aplica cuando la clave nunca se sincronizó.
    if (data?.data) localStorage.setItem('alqos_hc_factores_custom', JSON.stringify(data.data));
    else localStorage.removeItem('alqos_hc_factores_custom');
  } catch(e) { console.error('Error bajando hc_factores_custom:', e); }
}
// ─── CASO ESPECIAL: Huella de Carbono ─────────────────────────
// HuellaCarbono guarda en id:tenantId*2-1 (datos período) e id:tenantId*2 (historial)
// No es un array normal — hay que bajarlo diferente
// Fase C pendiente #3 (resuelto sin SQL): filtra por tenant_id además de traer las
// 2 filas propias, así no mezcla filas de otros tenants cuando haya más de uno.
async function bajarHuellaCarb() {
  const tenantId = getTenantId();
  if (!tenantId) return;
  try {
    const { data, error } = await supabase.from('huella_carbono').select('*').eq('tenant_id', tenantId);
    if (error) { console.error('Error bajando huella carbono:', error); return; }
    // Fase 8 (mismo criterio que bajarDatos()), a nivel de cada una de las 2
    // filas por separado: antes, un forEach sobre 0 filas (o solo 1 de las
    // 2) simplemente no tocaba nada, dejando la caché de la fila faltante
    // pegada de una sesión/tenant anterior -- ej. un tenant con período
    // actual pero sin historial todavía seguía mostrando el historial de
    // otro tenant/sesión en este dispositivo. Ahora cada clave se limpia
    // (removeItem) si su fila específica no vino, no solo si vinieron 0.
    const filas = data || [];
    const periodo   = filas.find(row => row.data && !row.data.historial);
    const historial = filas.find(row => row.data && row.data.historial);
    if (periodo)   localStorage.setItem('alqos_huella_carbono', JSON.stringify(periodo.data));
    else           localStorage.removeItem('alqos_huella_carbono');
    if (historial) localStorage.setItem('alqos_huella_historial', JSON.stringify(historial.data.historial));
    else           localStorage.removeItem('alqos_huella_historial');
  } catch(e) { console.error('Error bajando huella carbono:', e); }
}
// ─── SINCRONIZAR TODO al iniciar sesión ───────────────────────
export async function sincronizarTodo() {
  const keysArray = [
    'alqos_rrhh',
    'alqos_ncs',
    'alqos_ots',
    'alqos_acciones_correctivas',
    'alqos_caps',
    'alqos_fmea',
    'alqos_tpm',
    'alqos_capabilidad',
    'alqos_auditorias',
    'alqos_programa_auditorias',
    'alqos_analisis_causa',
    'alqos_docs',
    'alqos_ingreso_materiales',
    'alqos_haccp',
    'alqos_poes',
    'alqos_preprensa',
    'alqos_preprensa_planchas',
    'alqos_stock_pallets',
    'alqos_stock_movimientos',
    'alqos_ce_contactos',
    'alqos_ce_aranceles',
    'alqos_notas_comerciales',
    'alqos_agenda_comercial',
    'alqos_escritorio_calidad_tareas',
    'alqos_escritorio_calidad_stickers',
    // Las 7 keys de Portal Asesor (alqos_consultor_*) NO van acá a propósito: necesitan el
    // filtro server-side por organizacion_id/empresa_id que solo ConsultorHS.js puede armar,
    // porque sincronizarTodo() no tiene en contexto el usuario logueado ni sus organizaciones.
    // Las sincroniza su propio sincronizar()/sincronizarScoped al abrir el módulo — bajarlas acá
    // sería traer las 7 tablas completas sin WHERE, de todas las organizaciones, en cada login.
    'alqos_mapa_procesos',
    'alqos_instructivos',
    'alqos_centros_costo',
    'alqos_motor_costeo',
    'alqos_ventas',
    'alqos_cotizaciones',
    'alqos_tipos_material',
    'dd_proyectos',
    'alqos_oficina_tecnica',
    'alqos_trazabilidad',
    'alqos_ciberseg_inc',
    'alqos_ciberseg_activos',
    'alqos_ciberseg_ctrl',
    'alqos_despachos',
    'alqos_feedback',
    'et_specs',
    'alqos_plancontrol',
    'alqos_capabilidad_config',
    'alqos_produccion',
    'alqos_fsc_arqueo',
    'alqos_clientes',
    'alqos_proveedores',
    'alqos_compras',
    'alqos_sust_consumos',
    'alqos_sust_residuos',
    'alqos_sust_objetivos',
    'alqos_sust_aspectos',
    'alqos_sust_legal',
    'alqos_sust_config_consumos',
    'alqos_sust_config_residuos',
    'alqos_programas_calidad_cliente',
    'alqos_checklist_templates',
    'alqos_fase_familia_linea',
    'alqos_indicadores_mensuales',
    'alqos_familias',
    'alqos_maquinas',
    'alqos_conformes',
    'alqos_ce_exportaciones',
    'alqos_ce_importaciones',
    'alqos_plan_cuentas',
    'alqos_asientos',
    'alqos_asientos_lineas',
    'alqos_cxc_cxp',
    'alqos_movimientos_caja',
    'alqos_config_materiales',
    'alqos_news',
    'alqos_reportes_maquina',
  ];
  // Bajar todos en paralelo para ser más rápido
  await Promise.allSettled([
    ...keysArray.map(key => bajarDatos(key)),
    bajarHuellaCarb(),
    bajarHcFactoresCustom(),
    bajarDatosSingle('alqos_hs', 'hs_registros'),
    bajarDatosSingle('alqos_cnc_config', 'cnc_config'),
    bajarDatosSingle('alqos_aq_historial', 'aq_historial'),
    bajarDatosSingle('alqos_aq_umbrales', 'aq_umbrales'),
    bajarDatosSingle('alqos_cumplimiento', 'cumplimiento'),
    bajarDatosSingle('et_eliminados', 'et_eliminados'),
    bajarDatosSingle('alqos_finanzas_config', 'finanzas_config'),
  ]);
  // Avisar a los módulos que ya hay datos frescos de Supabase
  window.dispatchEvent(new Event('supabase-sync-complete'));
}
// ─── SUBIR objeto plano (no-array) a Supabase como id:tenantId ─
// Fase C pendiente #3 (resuelto sin SQL): id = tenant_id en vez de id:1 fijo,
// así cada tenant tiene su propia fila sin colisionar con otros.
export async function subirDatosSingle(storageKey, tabla) {
  if (!tabla) return;
  const tenantId = getTenantId();
  if (!tenantId) {
    console.error(`subirDatosSingle(${storageKey}): no hay tenant_id en la sesión, no se sube nada.`);
    return;
  }
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return;
    const data = JSON.parse(raw);
    await supabase.from(tabla).upsert({ id: tenantId, data, tenant_id: tenantId });
  } catch(e) { console.error(`Error subiendo single ${storageKey}:`, e); }
}
// ─── BAJAR objeto plano desde Supabase (id:tenantId) ──────────
export async function bajarDatosSingle(storageKey, tabla) {
  const tenantId = getTenantId();
  if (!tenantId) return false;
  try {
    const { data, error } = await supabase.from(tabla).select('data').eq('id', tenantId).maybeSingle();
    if (error) { console.error(`Error bajando single ${storageKey}:`, error); return false; }
    // Fase 8 (mismo criterio que bajarDatos()): 0 filas no es un error --
    // hay que limpiar la caché igual, no dejar la de una sesión anterior.
    // removeItem para que el consumidor caiga en el mismo default que ya
    // usa cuando la clave nunca se sincronizó (usado por CNC, aq_historial,
    // aq_umbrales, cumplimiento, et_eliminados, finanzas_config, hs).
    if (data?.data) localStorage.setItem(storageKey, JSON.stringify(data.data));
    else localStorage.removeItem(storageKey);
    return true;
  } catch(e) { console.error(`Error bajando single ${storageKey}:`, e); return false; }
}
// ─── ELIMINAR un item de Supabase + localStorage ──────────────
export async function eliminarDato(storageKey, itemId) {
  const tabla = TABLAS[storageKey];
  // 1. Borrar de localStorage
  try {
    const raw = localStorage.getItem(storageKey);
    if (raw) {
      const items = JSON.parse(raw);
      const filtrados = items.filter(i => i.id !== itemId);
      localStorage.setItem(storageKey, JSON.stringify(filtrados));
    }
  } catch(e) { console.error(`Error borrando local ${storageKey}:`, e); }
  // 2. Borrar de Supabase
  if (!tabla) return;
  try {
    await supabase.from(tabla).delete().eq('id', itemId);
  } catch(e) { console.error(`Error borrando Supabase ${storageKey}:`, e); }
}
